import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
// https://swiper6.vercel.app/react
import classnames from 'classnames';
import { useMemo } from 'react';
import { Image, VideoControl } from '../../common/components';
import { useMobile } from '../../common/hooks/use-mobile';
import { isClickable, transformInterval, transformPageMargins } from '../../common/utils';
import { get } from 'lodash';
import { useDesignContext } from '../../design-provider';
import { AspectRatioView } from '../../common/components/aspect-ratio-view';
import { VideoPathIframe } from '../../common/components/video-path-iframe';
export var Flow = function Flow(props) {
  var _props$imageAdList = props.imageAdList,
    imageAdList = _props$imageAdList === void 0 ? [] : _props$imageAdList,
    _props$imageRadius = props.imageRadius,
    imageRadius = _props$imageRadius === void 0 ? 'rightAngle' : _props$imageRadius,
    _props$pagePadding = props.pagePadding,
    pagePadding = _props$pagePadding === void 0 ? 0 : _props$pagePadding,
    _props$imageSpacing = props.imageSpacing,
    imageSpacing = _props$imageSpacing === void 0 ? 0 : _props$imageSpacing;
  var mobile = useMobile();
  var _useDesignContext = useDesignContext(),
    designOnLink = _useDesignContext.designOnLink;
  var borderRadiusStyle = {
    borderRadius: imageRadius === 'rightAngle' ? undefined : '20px'
  };
  var warpStyle = function warpStyle() {
    var styles = {};
    if (props.bgSetting === 'color') {
      styles.backgroundColor = props.bgColor;
    }
    if (props.bgSetting === 'pic') {
      styles.backgroundImage = "url(".concat(get(props.bgImage, 'path'), ")");
      styles.backgroundSize = '200px 200px';
      styles.backgroundRepeat = 'repeat';
    }
    return styles;
  };
  var aspectRatio = useMemo(function () {
    return {
      pc: Math.min.apply(Math, _toConsumableArray(imageAdList.map(function (item) {
        /**
         * 处理输入视频地址宽高比，视频的地址的宽高比使用的是图片的宽高比
         */
        if (item.fileType === 'videoPath') {
          return item.coverImage ? item.coverImage.web.aspectRatio : 1;
        }
        return item.fileValue.web.aspectRatio;
      }))),
      mobile: Math.min.apply(Math, _toConsumableArray(imageAdList.map(function (item) {
        /**
         * 处理输入视频地址宽高比，视频的地址的宽高比使用的是图片的宽高比
         */
        if (item.fileType === 'videoPath') {
          return item.coverImage ? item.coverImage.mobile.aspectRatio : 1;
        }
        return item.fileValue.mobile.aspectRatio;
      })))
    };
  }, [imageAdList]);
  var playBtnClassName = useMemo(function () {
    if (mobile) {
      return 'w-4 h-4';
    }
    return 'w-16 h-16';
  }, [mobile]);
  return _jsx("div", Object.assign({
    className: 'box-border grid w-full',
    style: Object.assign({
      paddingLeft: transformPageMargins(pagePadding, mobile),
      paddingRight: transformPageMargins(pagePadding, mobile),
      gap: transformInterval(imageSpacing, mobile, 'photoAds'),
      gridTemplateColumns: "repeat(".concat(imageAdList.length, ", minmax(0, 1fr))")
    }, warpStyle())
  }, {
    children: imageAdList.map(function (imageAd) {
      return _jsx(AspectRatioView, Object.assign({
        className: 'w-full',
        aspectRatio: mobile ? aspectRatio.mobile : aspectRatio.pc
      }, {
        children: function () {
          switch (imageAd.fileType) {
            case 'image':
              return _jsx("a", Object.assign({
                className: classnames('block', {
                  'cursor-pointer': isClickable(imageAd.target)
                }),
                href: designOnLink(imageAd.target)
              }, {
                children: _jsx(Image, {
                  className: classnames('w-full h-full', {
                    'cursor-pointer': isClickable(imageAd.target)
                  }),
                  style: borderRadiusStyle,
                  src: imageAd.fileValue
                })
              }));
            case 'video':
              return _jsx(VideoControl, {
                className: 'w-full h-full flex items-center justify-center',
                imageClassName: 'w-full h-full',
                videoClassName: 'w-full h-full',
                playBtnClassName: classnames(playBtnClassName),
                imageStyle: borderRadiusStyle,
                videoStyle: borderRadiusStyle,
                coverImage: imageAd.coverImage,
                fileValue: imageAd.fileValue
              });
            case 'videoPath':
              return _jsx(VideoPathIframe, {
                aspectRatio: aspectRatio,
                filePathValue: imageAd.filePathValue,
                coverImage: imageAd.coverImage,
                className: 'w-full h-full flex items-center justify-center',
                imageStyle: borderRadiusStyle,
                imageClassName: 'w-full h-full',
                playBtnClassName: classnames(playBtnClassName)
              });
          }
        }()
      }), imageAd.id);
    })
  }));
};